<template>
  <el-row>
    <el-col>
      <h1>Integem Raffle</h1>
    </el-col>
    <el-col>
      <el-form ref="form" :model="form" label-width="200px" label-position="top">
        <el-form-item
          label="NAME"
          prop="name"
          :rules="{ required: true, message: 'Must be entered!', trigger: 'blur' }"
        >
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          label="EMAIL"
          prop="email"
          :rules="{ required: true, type: 'email', message: 'Must be an email address!', trigger: 'blur' }"
        >
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item
          label="ZIP Code"
          prop="zipcode"
          :rules="[
            { required: true, type: 'number', message: '5 digits in length!', trigger: 'blur' },
            { validator: zipcodevalid, trigger: 'change' }
          ]"
        >
          <el-input v-model.number="form.zipcode"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" :loading="loading" @click="send">SEND</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'Raffle',
  title: 'RAFFLE',
  data: function() {
    return {
      loading: false,
      form: {
        name: '',
        email: '',
        zipcode: ''
      },
      zipcodevalid: (rule, value, callback) => {
        // eslint-disable-next-line
        console.log(value.toString().length)
        if (value.toString().length === 5) {
          callback()
        } else {
          callback(new Error('5 digits in length!'))
        }
      }
    }
  },
  sockets: {
    connect() {
      // eslint-disable-next-line
      console.log('connected')
    }
  },
  methods: {
    send() {
      this.$refs.form.validate(valid => {
        // esline-disable-next-line
        // console.log(valid, data)
        if (valid) {
          this.loading = true
          this.$socket.emit('sendEmail', this.form, msg => {
            // esline-disable-next-line
            // console.log(msg)
            this.$message[msg.type](msg.message)
            this.loading = false
          })
        }
        // console.log('error submit!!');
        return valid
      })
    }
  }
}
</script>

<style scoped>
h1 {
  text-align: center;
  font-family: 'Courier New', Courier, monospace;
  padding-top: 20px;
}

button {
  display: block;
  margin: auto;
}
</style>
